<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-09 16:57:18
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-27 11:14:48
 * @FilePath: \sns-user-frontend\src\components\report.vue
 * @Description: 
-->
<template>
  <Dialog
    v-model:visible="visible"
    :showFoot="false"
  >
    <div class="report">
      <div class="title">
        <p>{{reasonOnly ? $t('reason') :$t('report')}}</p>
        <svg-icon @click="visible = false" class="icon-close" name="icon-close"></svg-icon>
      </div>
      <el-scrollbar class="report-content" :class="reasonOnly ? 'reason-only' : ''" :max-height="reasonOnly ? 'calc(100vh - 120px - 219px)' : 'calc(100vh - 120px - 411px)'">
        <el-radio-group v-model="reasonId">
          <el-radio
            :label="reason.id"
            v-for="reason in reasons"
            :key="reason.id"
          >
            {{ reason.name }}
          </el-radio>
        </el-radio-group>
      </el-scrollbar>
      <div class="reason-detail" v-if="!reasonOnly">
        <el-input
          v-model="reasonDetail"
          :maxlength="systemStore.cloudConfig.reportReasonLimit"
          :placeholder="$t('reportPlacement')"
          show-word-limit
          type="textarea"
          resize="none"
          :autofocus="true"
        />
      </div>
      <div class="btns">
        <el-button round @click="hideDialog">{{$t('cancel')}}</el-button>
        <el-button :disabled="!reasonId" class="confirm" round @click="onReport">{{$t('submit')}}</el-button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>

import { onMounted, ref, watch, getCurrentInstance } from 'vue'

import { useSystemStore } from '@/stores/system'

import http from '@/service'
const { proxy } = getCurrentInstance()

const systemStore = useSystemStore()

const emit = defineEmits(['update:modelValue', 'afterSelect', 'reported'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  reportId: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: '1'
  },
  // 是否仅需要选择原因的功能，true时只需选择原因，false为默认的举报弹窗功能
  reasonOnly: {
    type: Boolean,
    default: false
  }
})

// 抽屉开关
const visible = ref(false)

const showField = ref(false)

const reasons = ref([])

const reasonId = ref('')

const reasonDetail = ref('')

const onSelectReason = (id) => {
  reasonId.value = id
  showField.value = true
}

const onReport = () => {
  if (props.reasonOnly) {
    emit('afterSelect', reasons.value.filter((item) => item.id === reasonId.value)[0])
    return
  }
  http.report({
    description: reasonDetail.value,
    reason: reasonId.value,
    targetId: props.reportId,
    type: props.type
  }).then(res => {
    if (res.code === 200) {
      visible.value = false
      proxy.$toast({
        message: proxy.$t('reportSuccess')
      })
    } else {
      proxy.$toast({
        message: res.msg
      })
    }
    emit('reported', {
      code: res.code,
      msg: res.msg
    })
  })
}

const hideDialog = () => {
  visible.value = false
}

watch(() => visible, (val) => {
  if (val.value) {
    switch (props.type) {
      case '1': 
        reasons.value = [ ...systemStore.getUserReportReasons ]
        break
      case '2': 
        reasons.value = [ ...systemStore.getThreadReportReasons ]
        break
      case '3': 
        reasons.value = [ ...systemStore.getCommentReportReasons ]
        break
      case '4': 
        reasons.value = [ ...systemStore.getReplyReportReasons ]
        break
      case '5': 
        reasons.value = [ ...systemStore.getMessageReportReasons ]
        break
      default:
    }
  } else {
    reasons.value = []
    reasonId.value = ''
    reasonDetail.value = ''
    showField.value = false
    emit('update:modelValue', val.value)
  }
}, {
  immediate: true,
  deep: true
})

// 同步开关
watch(() => props.modelValue, async (val) => {
  if (val) {
      // 拉新活动受邀人不调用举报列表
    if (!location.pathname.includes('invitation')){
      // 获取举报列表
      await systemStore.getReportReasons()
    }
  }
  visible.value = val
}, {
  immediate: true,
})

onMounted(async () => {
  
})
</script>

<style lang="postcss" scoped>
.report {
  width: 768px;
  .title {
    width: 100%;
    text-align: center;
    margin: 40px 0 24px;
    color: #262626;
    font-size: 24px;
    font-family: 'orbit-M';
    .svg-icon {
      position: absolute;
      width: 32px;
      height: 32px;
      top: 40px;
      right: 40px;
      color: var(--text-primary);
    }
  }
  .report-content {
    max-height: 448px;
    overflow: auto;
    .el-radio-group {
      --el-color-primary: var(--theme);
      display: flex;
      flex-flow: column wrap;
      align-items: flex-start;
      justify-content: flex-start;
      :deep(.el-radio) {
        color: var(--text-primary);
        --el-radio-input-width: 16px;
        --el-radio-input-height: 16px;
        --el-radio-font-size: 16px;
        display: flex;
        flex-flow: row-reverse nowrap;
        align-items: center;
        justify-content: space-between;
        width: 768px;
        padding: 0 40px;
        box-sizing: border-box;
        height: 56px;
        .el-radio__label {
          padding: 0;
        }
        .el-radio__inner::after {
          width: 6px;
          height: 6px;
        }
      }
    }
  }
  .reason-only {
    max-height: 640px;
  }
  .btns {
    height: 124px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      --el-font-size-base: 16px;
      --el-button-hover-text-color: unset;
      --el-button-hover-bg-color: transparent;
      --el-button-active-bg-color: transparent;
      --el-button-hover-border-color: var(--outline);
      --el-button-active-border-color: var(--outline);
      width: 338px;
      height: 48px;
      border-radius: var(--button-radius);
      color: var(--text-primary);
    }
    .confirm {
      --el-button-bg-color: var(--theme);
      --el-button-active-color: var(--theme);
      --el-button-hover-bg-color: var(--theme);
      --el-button-active-bg-color: var(--theme);
      --el-button-disabled-text-color: var(--text-primary-reverse);
      --el-button-disabled-bg-color: var(--theme-disabled);
      border: none;
      color: #FFF;
      margin-left: 12px;
    }
  }
  .reason-detail {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
    box-sizing: border-box;
    height: 192px;
  }
  .el-textarea {
    --el-text-color-placeholder: var(--text-hint);
    --el-text-color-regular: var(--text-primary);
    --el-color-info: var(--text-hint);
    --el-fill-color-blank: #F9F9F9;
    border: none;
    :deep(textarea) {
      height: 160px;
      padding: 24px;
      font-size: 18px;
      line-height: 150%;
      background-color: #F6F6F6;
      border-radius: 24px;
      outline-style: none;
      box-shadow: none;
    }
    :deep(.el-input__count) {
      bottom: 24px;
      right: 24px;
    }
  }
}
:deep(.el-dialog) {
  overflow: hidden;
  background: #fff;
  max-height: calc(100vh - 120px);
}
</style>